export const logistics = [
    {
        path: '/logistics-mag',
        name: '物流管理',
        component: () => import("@/views/layout/index.vue"),
        isDelete:false,
        children: [
            {
                path: 'details',
                component: () => import("@/views/sellerAdmin/logistics/details/index.vue"),
                name: '物流合伙人详情',
                meta: {
                    hidden: true,
                    key: 13003,
                },
            },
            // {
            //   path: 'tx-record',
            //   component: () => import("@/views/sellerAdmin/logistics/tx-record/index.vue"),
            //   name: '提现记录',
            //   meta: {
            //       hidden: true,
            //       key: 13005,
            //   },
            // },
            {
                path: 'withdraw',
                component: () => import("@/views/sellerAdmin/withdraw/second/index.vue"),
                name: '商家配置',
                meta: {
                    hidden: true,
                    key: 13006,
                },
            },
            {
                path: 'order',
                component: () => import("@/views/sellerAdmin/logistics/order/index.vue"),
                name: '订单管理',
                meta: {
                    hidden: true,
                    key: 13001,
                },
                redirect: 'order/list',
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/logistics/order/default/index.vue"),
                        name: '订单列表',
                        meta: {
                            hidden: true,
                            parent: '/logistics-mag/order',
                            isShow:false,
                            key: 13001,
                        },
                    },
                    {
                        path: 'delivery/:id',
                        component: () => import("@/views/sellerAdmin/logistics/order/delivery/index.vue"),
                        name: '订单发货',
                        meta: {
                            hidden: true,
                            key:13001,
                            isShow:false,
                            parent: '/logistics-mag/order'
                        },
                    },
                    {
                        path: 'details/:id/:isEdit?',
                        component: () => import("@/views/sellerAdmin/logistics/order/details/index.vue"),
                        name: '订单详情',
                        meta: {
                            hidden: true,
                            parent: '/logistics-mag/order',
                            isShow:false,
                            key: 13001,
                        },
                    },
                    {
                        path: 'delivery/:id/:isEdit?',
                        component: () => import("@/views/sellerAdmin/logistics/order/delivery/index.vue"),
                        name: '订单详情',
                        meta: {
                            hidden: true,
                            parent: '/logistics-mag/order',
                            isShow:false,
                            key: 13002,
                        },
                    },
                ]
            },
            {
                path: 'refund',
                component: () => import("@/views/sellerAdmin/marketing/trade/refund-processing/index.vue"),
                name: '退款处理',

                meta: {
                    hidden: true,
                    key:13002,
                    url:'/logistics-mag/order',
                },
            },
            {
                path: 'return',
                component: () => import("@/views/sellerAdmin/marketing/trade/return-processing/index.vue"),
                name: '退货处理',

                meta: {
                    hidden: true,
                    key:13003,
                    url: '/logistics-mag/order',
                },
            },
        ]
    },

]
